import html2pdf from 'html2pdf.js';

const { ajax_url } = scriptData;

const initPdfHandler = () => {
    const form = document.querySelector('#questionResultForm');
    if (!form) {
        return;
    }
    form.addEventListener('submit', event => {
        event.preventDefault();

        const email = document.querySelector('.js-email-input').value;
        if (!email) {
            alert('Please enter a valid email address.');
            return;
        }

        const nonce = document.getElementById('generate_pdf_nonce').value;
        const formTitle = document.querySelector('.js-form-title').value || '';

        const { origin, pathname } = window.location;
        const redirect_url = `${origin}${pathname}`;

        const content = document.querySelector('.article-content');

        const elementsToRemove = content.querySelectorAll('.js-remove-from-pdf');
        elementsToRemove.forEach(element => element.remove());

        const options = {
            margin: [10, 10, 10, 10],
            filename: 'questionform-result.pdf',
            image: {
                type: 'jpeg',
                quality: 0.75,
            },
            pagebreak: {
                mode: ['avoid-all'],
            },
            html2canvas: {
                scale: 2,
                useCORS: true,
            },
            jsPDF: {
                unit: 'mm',
                format: 'letter',
                orientation: 'portrait',
            },
        };

        html2pdf()
            .set(options)
            .from(content)
            .outputPdf('arraybuffer')
            .then(function (pdfData) {
                const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });

                const formData = new FormData();
                formData.append('action', 'generate_and_email_pdf');
                formData.append('generate_pdf_nonce', nonce);
                formData.append('email', email);
                formData.append('pdf', pdfBlob);
                formData.append('form_title', formTitle);

                fetch(ajax_url, {
                    method: 'POST',
                    body: formData,
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            window.location.href = redirect_url + '?email_sent=true';
                        } else {
                            window.location.href = redirect_url + '?email_sent=false';
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        window.location.href = redirect_url + '?email_sent=false';
                    });
            });
    });
};

document.addEventListener('DOMContentLoaded', initPdfHandler);
